import React from "react";
import { ArrowDown } from "lucide-react";
import { IMAGES } from "../../data/content";

const HEADER_OFFSET = 64;

const easeInOutCubic = (t) =>
  t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

const smoothScrollToId = (id, duration = 1200) => {
  const el = document.getElementById(id);
  if (!el) return;
  const targetY =
    el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;

  const prefersReduced = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;
  if (prefersReduced) {
    window.scrollTo(0, targetY);
    return;
  }

  const startY = window.scrollY;
  const diff = targetY - startY;
  let start;
  const step = (ts) => {
    if (start === undefined) start = ts;
    const t = Math.min((ts - start) / duration, 1);
    window.scrollTo(0, startY + diff * easeInOutCubic(t));
    if (t < 1) requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
};

const handleAnchor = (e, id) => {
  e.preventDefault();
  smoothScrollToId(id);
};

export const Hero = () => {
  return (
    <section id="top" data-testid="hero" className="relative">
      <div className="relative h-[52vh] min-h-[380px] md:h-[82vh] md:min-h-[560px] w-full overflow-hidden">
        <img
          src={IMAGES.heroBanner}
          alt="Institut de beauté & bien-être Ninaa Beauty à Toulouse centre"
          className="absolute inset-0 h-full w-full object-cover"
          loading="eager"
        />
        {/* overlays for legibility — darken behind the text, keep warm edges */}
        <div className="absolute inset-0 bg-[#2b2a27]/25" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_55%_at_center,rgba(43,42,39,0.55)_0%,rgba(43,42,39,0.15)_55%,transparent_80%)]" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2b2a27]/45 via-transparent to-[#2b2a27]/20" />

        <div className="relative z-10 h-full max-w-5xl mx-auto px-6 flex flex-col items-center justify-center text-center">
          <p className="hero-rise hero-rise-1 text-[11px] md:text-xs tracking-[0.35em] uppercase text-white/85 mb-6">
            Institut de beauté & bien-être · esthéticienne
          </p>
          <h1 className="hero-rise hero-rise-2 font-serif-display font-light leading-[0.95] text-white text-6xl sm:text-7xl md:text-8xl [text-shadow:_0_2px_24px_rgba(43,42,39,0.55)]">
            Ninaa Beauty
          </h1>
          <p className="hero-rise hero-rise-3 mt-6 text-white/90 text-base md:text-lg leading-relaxed max-w-lg [text-shadow:_0_1px_12px_rgba(43,42,39,0.5)]">
            Un lieu pour prendre soin de vous au cœur de Toulouse.
          </p>

          <div className="hero-rise hero-rise-4 mt-10 flex flex-nowrap items-center justify-center gap-4 sm:gap-7">
            <a
              href="#prestations"
              data-testid="hero-cta"
              onClick={(e) => handleAnchor(e, "prestations")}
              className="inline-flex items-center justify-center gap-1.5 sm:gap-2 rounded-full border border-white/70 text-white px-4 sm:px-7 py-3 sm:py-3.5 text-[11px] sm:text-sm whitespace-nowrap hover:bg-white/10 transition-colors"
            >
              Voir les prestations <ArrowDown size={14} />
            </a>
            <a
              href="#contact"
              data-testid="hero-cta-contact"
              onClick={(e) => handleAnchor(e, "contact")}
              className="inline-flex items-center justify-center rounded-full border border-white/70 text-white px-4 sm:px-7 py-3 sm:py-3.5 text-[11px] sm:text-sm whitespace-nowrap hover:bg-white/10 transition-colors"
            >
              Prendre rendez-vous
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
